// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

const container = document.getElementById('root') as HTMLElement;

const tree = (
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </React.StrictMode>
);

// 프리렌더링된 HTML이 있으면 hydrate, 아니면 일반 렌더
if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, tree);
} else {
    ReactDOM.createRoot(container).render(tree);
}
